import { Component, EventEmitter, HostListener, inject, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
    selector: 'app-header-profile',
    templateUrl: './header-profile.component.html',
    styleUrls: ['./header-profile.component.scss'],
    standalone: false
})
export class HeaderProfileComponent {
    private router = inject(Router);
    private auth = inject(AuthService);
    isMenuOpen = false;
    readonly user$ = this.auth.user$;

    @Output() toggleSidebar = new EventEmitter<void>();

    onLogout(): void {
        this.auth.logout();
        this.router.navigateByUrl('/auth', { replaceUrl: true });
    }


    toggleMenu(): void {
        this.isMenuOpen = !this.isMenuOpen;
    }

    @HostListener('document:click', ['$event'])
    onDocClick(ev: MouseEvent) {
        const el = ev.target as HTMLElement;
        if (!el.closest('.profile')) this.isMenuOpen = false;
    }

}
